import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import React, { useEffect, useRef, useState } from 'react';
import { loadData } from '@jelly/utils';
export var PAGE_ONE = 1;
export var ResultContext = /*#__PURE__*/React.createContext();

/**
 * This is the Generic Provider
 * Contains all the context values used throughout the ResultList and containers
 * Including the logic for fetching new data from Swiftype, handles tab switching and pagination
 */
function ResultProvider(_ref) {
  var children = _ref.children,
      mainContent = _ref.mainContent,
      generateURL = _ref.generateURL,
      page = _ref.page,
      searchData = _ref.search,
      tab = _ref.tab,
      tabs = _ref.tabs,
      loadMore = _ref.loadMore;

  var _useState = useState(_defineProperty({}, tab, mainContent)),
      _useState2 = _slicedToArray(_useState, 2),
      results = _useState2[0],
      setResults = _useState2[1];

  var _useState4 = useState(searchData),
      _useState5 = _slicedToArray(_useState4, 2),
      search = _useState5[0],
      setSearch = _useState5[1];

  var _useState6 = useState(false),
      _useState7 = _slicedToArray(_useState6, 2),
      isLoading = _useState7[0],
      setIsLoading = _useState7[1];

  var isFirstRender = useRef(true);

  var handleLoadMoreResults = function handleLoadMoreResults() {
    setIsLoading(true);
    loadData(generateURL(results[tab].skipInterval)).then(function (_ref2) {
      var mainContent = _ref2.mainContent;
      setResults(function (results) {
        var currentTab = results[tab] ? results[tab] : {
          content: []
        };
        return _objectSpread(_objectSpread({}, results), {}, _defineProperty({}, tab, {
          content: [].concat(_toConsumableArray(currentTab.content), _toConsumableArray(mainContent.content)),
          loadMore: mainContent.loadMore,
          skipInterval: mainContent.skipInterval
        }));
      });
      setIsLoading(false);
    });
  }; // First data is coming from the backend


  useEffect(function () {
    if (!isFirstRender.current) {
      setIsLoading(true);
      loadData(generateURL()).then(function (_ref3) {
        var mainContent = _ref3.mainContent,
            search = _ref3.search;
        setResults(_defineProperty({}, tab, mainContent));
        setSearch(search);
        setIsLoading(false);
      });
    }

    isFirstRender.current = false;
  }, [tab, page, generateURL, loadMore]);
  return /*#__PURE__*/React.createElement(ResultContext.Provider, {
    value: {
      isLoading: isLoading,
      handleLoadMoreResults: handleLoadMoreResults,
      loadMore: loadMore,
      tabs: tabs,
      results: results,
      search: search
    }
  }, children);
}

export default ResultProvider;